import { useRef } from 'react';

const usePromise = () => {
  let resolveFunc;
  const promise = useRef(
    new Promise((resolve) => {
      resolveFunc = resolve;
    })
  ).current;

  const resolvePromise = useRef(resolveFunc).current;

  return { promise, resolvePromise };
};

export default usePromise;
